<template>
    <div class="menu-body">
        <Loader v-if="showLoader" />
        <Breadcrumb />
        <div class="main-con" style="padding: 0">
            <div class="edit-btn-div">
                <b-button class="btn edit-btn" pill v-if="
                    !editMode &&
                    oeeSelectedMonth === currentMonth &&
                    oeeSelectedYear === new Date().getFullYear() &&
                    loggedInUserData.plantId === plantId.plantId &&
                    ($oidc.userProfile.roles.includes(roles.PLANTPILLARLEADER) || $oidc.userProfile.roles.includes(roles.PLANTPOLEADER))
                " variant="outline-primary" @click="turnOnEditMode()">
                    Edit
                </b-button>

                <b-button class="btn edit-btn" pill variant="outline-primary"
                    @click="$router.push('/machine-assessment')"> Back </b-button>
            </div>
            <div class="even-space-vertical-align" v-if="!editMode">
                <div class="mat-info-con main-tab-act default-font-color">You have already successfully submitted the
                    machines list.</div>
                <div class="mat-info-con main-tab-act default-font-color">Last Updated on ({{ lastUpdatedOn }})</div>
            </div>
            <div class="even-space-vertical-align" v-else>
                <div class="mat-info-con main-tab-act default-font-color">
                    The modified group definition will be applicable from {{ fromMonth }}
                    till end of the year unless modified in future months.
                    <br />
                    You have already successfully submitted the machine list (Last updated on {{ lastUpdatedOn }}). You
                    may edit from the following existing list and save the changes.
                </div>
                <div class="mat-info-con main-tab-act default-font-color"></div>
            </div>
        </div>
        <div class="main-con">
            <div class="mat-info-con even-space-vertical-align">
                <div class="plant-dd" style="width: 100%; display: flex">
                    <div class="plant-dd">
                        <label for="plant" class="form-label select-lable lable-text"> Plant </label>
                        <select disabled class="form-control select-text select-text-pd cust-st-icon" id="plantId"
                            :value="plantSelectedInAsmtHome" @change="plantChanged($event)">
                            <option v-for="plant in plantList" v-bind:key="plant.plantId" :value="plant.plantId">
                                {{ plant.plantName + ", " + plant.regionCode }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- loop starts from here -->
            <div class="stacked-elements" v-for="(group, noOfGroup) in groupList" :key="noOfGroup">
                <div class="mat-info-con main-tab-act default-font-color"
                    v-if="constraintValidityArr.length && constraintValidityArr[noOfGroup].hasOwnProperty('type')"
                    style="padding: 0 0 2rem 0 !important">
                    {{ constraintValidityArr[noOfGroup].type }}
                    group definition is applicable from
                    {{ constraintValidityArr[noOfGroup].historyFromMonth }}
                    to {{ constraintValidityArr[noOfGroup].historyToMonth }}.
                </div>
                <div class="plant-dd" style="padding: 1rem 0">
                    <label for="workcenter" class="form-label select-lable lable-text"> Work Center </label>
                    <select class="form-control select-text select-text-pd cust-st-icon" id="workcenterId" disabled
                        v-model="group.workCenterSelected" @change="getMachinesForList(noOfGroup)">
                        <option v-for="wc1 in workCenterList" v-bind:key="wc1.workcenterId" :value="wc1.workcenterId">
                            {{ wc1.workcenterName }}
                        </option>
                    </select>
                </div>
                <div class="card-main-tl">Group {{ noOfGroup + 1 }}</div>
                <div class="card-tab-act" style="opacity: 0.5; padding: 0.8rem 0">Select Machines</div>

                <div class="col-md-12 no-padding even-space-vertical-align">
                    <div class="col-md-8 border-box scroll" v-if="group.machineList.length > 1">
                        <div v-for="ml1 in group.machineList" :key="ml1.machineId"
                            class="individual-checkbox machine-list">
                            <div class="chk-container">
                                <b-form-checkbox type="checkbox" :checked="ml1.machineChecked" name="executive"
                                    :disabled="!editMode" class="radio"
                                    @change="onMachineCheck($event, noOfGroup, group, ml1)">
                                    {{ ml1.machineName }}
                                </b-form-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8 border-box scroll no-data-block" v-else>
                        <img alt="no data" src="@/assets/No_Data.svg" />
                        <div class="ed-date">No Data Found</div>
                    </div>
                    <div class="col-md-4 alter-of-border-box">
                        <div class="plant-card-constraint">
                            <div class="info-card-lable">Number of Constrained Machines Selected</div>
                            <div class="info-card-value">
                                {{ group.noOfMachinesforGrp }}
                            </div>
                        </div>
                        <div style="width: 22rem">
                            <label for="constName" class="form-label select-lable lable-text"> Constrained WC Name<span
                                    class="require-cl">*</span> </label>
                            <b-form-input type="text" v-model="group.constraintGrpName" id="constName" maxlength="30"
                                :disabled="!editMode" class="form-control select-text select-text-pd" />
                        </div>
                        <div style="width: 22rem">
                            <label for="constraintTypeId" class="form-label select-lable lable-text"> Type of
                                Constraint<span class="require-cl">*</span> </label>
                            <select class="form-control select-text select-text-pd cust-st-icon" id="constraintTypeId"
                                :disabled="!editMode" v-model="group.constraintTypeId">
                                <option disabled value="-1">Select</option>
                                <option v-for="ct in constraintType" v-bind:key="ct.constraintTypeId"
                                    :value="ct.constraintTypeId">
                                    {{ ct.constraintType }}
                                </option>
                            </select>
                        </div>
                        <div class="button-div" v-if="noOfGroup === groupList.length - 1 && editMode">
                            <b-button pill variant="outline-primary" style="padding: 0.25rem 1rem; margin-left: 1rem"
                                class="btn cancel-save-btn button-sm" @click="saveManualData()">
                                Save Changes
                            </b-button>
                        </div>
                        <div class="button-div" v-else></div>
                    </div>
                </div>
            </div>
            <!-- loop ends here -->
        </div>

        <!-- alert msg popup -->
        <b-modal id="alert-msg" size="lg" ref="alertMsg" hide-footer hide-header :title="headText" :visible="showPopup">
            <div class="row col-12 page-content-regular" style="padding: 2rem 1rem">
                <p>
                    <span class="page-heading-tab">
                        {{ errorMsg }}
                    </span>
                </p>
            </div>
            <div class="button-div" style="justify-content: right; width: 100%">
                <b-button pill variant="outline-primary" style="padding: 0.25rem 1rem; margin-left: 1rem"
                    class="btn cancel-save-btn button-sm" @click="closeAlertPopup()"> OK </b-button>
            </div>
        </b-modal>
        <!-- alert msg popup -->
    </div>
</template>
<script>
import "../../../common/css/CommonStyle.css";
import "../../../common/css/font-categories.css";
import Breadcrumb from "../../../components/common/Breadcrumb.vue";
import Loader from "../../../components/common/Loader.vue";
import ApiCalls from "@/common/api/apiCalls";
import Api from "../../../common/constants/api";
import { mapGetters } from "vuex";
import roles from "@/common/constants/roles";
import moment from "moment";

export default {
    name: "ConstraintMachinesGroup",
    data() {
        return {
            currentMonth: new Date().getMonth() + 1,
            errorMsg: "",
            lastUpdatedOn: moment(new Date()).format("DD-MMM-YYYY"),
            showPopup: false,
            editMode: false,
            headText: "",
            shouldMovePrev: false,
            maxGroupCount: 2,
            showLoader: true,
            plantList: [],
            machineList: [],
            workCenterList1: [],
            workCenterList2: [],
            workcenterId1: 2,
            workcenterId2: 2,
            machineList1: [],
            machineList2: [],
            constraintTypeId1: 1,
            constraintTypeId2: 1,
            plantId: {},
            oldMachineList: [],
            committedYear: [],
            constraintHeadersDtl: [],
            noOfMachinesforGrp1: 0,
            noOfMachinesforGrp2: 0,
            constraintGrp1: "",
            constraintGrp2: "",
            extMachineList1: "",
            committedYr: new Date().getFullYear(),
            workCenterList: [],
            fromMonth: moment(new Date()).format("MMM-YYYY"),
            constraintValidityArr: [],
            groupList: [
                {
                    groupNo: 1,
                    workCenterSelected: 1,
                    machineList: [],
                    noOfMachinesforGrp: 0,
                    constraintGrpName: "",
                    isPrevConstraint: "N",
                    constraintTypeId: "-1"
                }
            ],
            constraintType: [
                {
                    constraintTypeId: "Primary",
                    constraintType: "Primary"
                },
                {
                    constraintTypeId: "Secondary",
                    constraintType: "Secondary"
                },
                {
                    constraintTypeId: "Tertiary",
                    constraintType: "Tertiary"
                }
            ],
            roles: roles,
            constraintHeaders: [
                {
                    key: "ConstraintListName",
                    label: "Constraint List Name",
                    sortable: false
                },
                {
                    key: "WC",
                    label: "Work Center",
                    sortable: false
                },
                {
                    key: "MCH",
                    label: "#MCH",
                    sortable: false
                },
                {
                    key: "TypeofConstraint",
                    label: "Type of Constraint",
                    sortable: false
                },
                {
                    key: "MoveDatatoNextYear",
                    label: "Move Data to Next Year",
                    sortable: false
                }
            ],
            isPrimaryAvailable: true
        };
    },
    components: {
        Breadcrumb,
        Loader
    },

    beforeCreate() {
        this.$store.dispatch("selectedMenu", {
            main: 4,
            subMenu: 5
        });
        this.$store.dispatch("breadcrumb", {
            title: "View Constrained Machines Group - ",
            breadcrumb: [
                { name: "Home / ", primary: true, redirect: "/dashboard" },
                { name: "Machine Replication", primary: false }
            ]
        });
    },
    mounted() { },
    created() {
        console.log("this.oeeSelectedMonth", this.oeeSelectedMonth);
        this.$store.dispatch("breadcrumb", {
            title: "View Constrained Machines Group - " + moment(new Date(this.oeeSelectedYear, this.oeeSelectedMonth - 1)).format("MMM-YYYY"),
            breadcrumb: [
                { name: "Home / ", primary: true, redirect: "/dashboard" },
                { name: "Machine Replication", primary: false }
            ]
        });
        this.getPlantDetails();
    },
    computed: {
        ...mapGetters(["plantSelectedInAsmtHome", "loggedInUserData", "oeeSelectedMonth", "oeeSelectedYear"])
    },
    methods: {
        turnOnEditMode() {
            this.editMode = true;
            this.$store.dispatch("breadcrumb", {
                title: "Edit Constrained Machines Group - " + moment(new Date().setMonth(this.oeeSelectedMonth - 1)).format("MMM-YYYY"),
                breadcrumb: [
                    { name: "Home / ", primary: true, redirect: "/dashboard" },
                    { name: "Machine Replication", primary: false }
                ]
            });
        },
        turnOffEditMode() {
            this.editMode = false;
            this.showLoader = true;
            this.getConstraintDtlsForEdit();
            this.$store.dispatch("breadcrumb", {
                title: "View Constrained Machines Group - " + moment(new Date().setMonth(this.oeeSelectedMonth - 1)).format("MMM-YYYY"),
                breadcrumb: [
                    { name: "Home / ", primary: true, redirect: "/dashboard" },
                    { name: "Machine Replication", primary: false }
                ]
            });
        },
        getPlantDetails() {
            console.log("getPlantDetails");
            ApiCalls.httpCallDetails(Api.GETPLANTLIST, "get").then((data) => {
                this.plantList = data.data;
                let plantId = this.plantSelectedInAsmtHome ? this.plantSelectedInAsmtHome : this.plantList[0].plantId;
                let index = 0;
                if (this.plantSelectedInAsmtHome) index = this.plantList.findIndex((el) => el.plantId == this.plantSelectedInAsmtHome);
                else if (this.loggedInUserData.plantId) {
                    let plantIndex = this.plantList.findIndex((el) => el.plantId == this.loggedInUserData.plantId);
                    if (plantIndex > -1) {
                        index = plantIndex;
                        plantId = this.plantList[index].plantId;
                    }
                } else if (this.loggedInUserData.regionName) {
                    let plantIndex = this.plantList.findIndex((el) => el.regionName == this.loggedInUserData.regionName);
                    if (plantIndex > -1) {
                        index = plantIndex;
                        plantId = this.plantList[index].plantId;
                    }
                }
                this.plantId = this.plantList[index];
                this.$store.dispatch("plantSelectedInAsmtHome", plantId);
                this.getWorkCenterDetailsForList();
                this.checkGroupStatus();
            });
        },
        checkGroupStatus() {
            console.log("// GETALLCONSTRAINTTYPE");
            ApiCalls.httpCallDetails(`${Api.GETGROUPSTATUS}/${this.plantId.plantId}/${this.oeeSelectedYear}/${this.oeeSelectedMonth}`, "get").then((sdata) => {
                ApiCalls.httpCallDetails(`${Api.GETALLCONSTRAINTTYPE}`, "get").then((tdata) => {
                    this.constraintType = [];
                    let allCreated = 0;
                    this.maxGroupCount = sdata.data.maxGroup;
                    for (let index = 0; index < sdata.data.maxGroup; index++) {
                        const element = tdata.data[index];

                        if (element.typeId === 1) this.isPrimaryAvailable = !sdata.data.groupCreated.includes(element.typeId);
                        this.constraintType.push({
                            constraintTypeId: element.typeId,
                            constraintType: element.typeName,
                            alreadyExist: sdata.data.groupCreated.includes(element.typeId)
                        });
                        allCreated = sdata.data.groupCreated.includes(element.typeId) ? allCreated + 1 : allCreated;
                    }


                    this.getConstraintDtlsForEdit();
                });
            });
        },
        plantChanged(event) {
            this.showLoader = true;
            this.$store.dispatch("plantSelectedInAsmtHome", event.target.value);
            this.plantId = this.plantList.find((el) => el.plantId == event.target.value);
            this.getWorkCenterDetailsForList();
            this.checkGroupStatus();
        },
        getWorkCenterDetailsForList() {
            ApiCalls.httpCallDetails(Api.MRWORKCENTERALL, "post", { regionId: this.plantId.regionId }).then((data) => {
                this.workCenterList = data.data;
                this.groupList.forEach((_group, index) => {
                    this.groupList[index].workCenterSelected = data.data[index].workcenterId;
                    this.getMachinesForList(index);
                });
            });
        },
        getMachinesForList(pos) {
            this.showLoader = true;
            console.log("getMachineFilter");
            let machinePayload = {
                plantId: this.plantId.plantId,
                workcenterId: this.groupList[pos].workCenterSelected,
                regionId: this.plantId.regionId
            };
            console.log("machinePayload", machinePayload);
            ApiCalls.httpCallDetails(Api.MRMACHINEDROPDOWN, "post", machinePayload).then((data) => {
                console.log(data.data);
                this.groupList[pos].machineList = data.data.map((machine) => {
                    return {
                        machineId: machine.machineId,
                        machineName: machine.machineName,
                        machineChecked: false
                    };
                });
                this.groupList[pos].machineList.unshift({
                    machineId: 0,
                    machineName: "All",
                    machineChecked: false
                });
                this.groupList[pos].isPrevConstraint = "N";
                this.showLoader = false;
            });
        },
        onMachineCheck(event, pos, group, ml1) {
            console.log("Checked");
            console.log(event, pos, group, ml1);
            if (ml1.machineName === "All") {
                this.groupList[pos].machineList.forEach((machine) => {
                    machine.machineChecked = event;
                });
            } else {
                let checkedPos = this.groupList[pos].machineList.findIndex((wc) => wc.machineId === ml1.machineId);
                this.groupList[pos].machineList[checkedPos].machineChecked = event;
            }
            let totalMarked = 0;
            this.groupList[pos].machineList.forEach((machine) => {
                if (machine.machineChecked && machine.machineId !== 0) totalMarked += 1;
            });
            group.noOfMachinesforGrp = totalMarked;
        },
        addNewGroup() {
            console.log(this.groupList);
            this.groupList.push({
                groupNo: 2,
                workCenterSelected: this.workCenterList[0].workcenterId,
                machineList: [],
                noOfMachinesforGrp: 0,
                constraintGrpName: "",
                constraintTypeId: "Secondary",
                isPrevConstraint: "N"
            });
            this.getMachinesForList(this.groupList.length - 1);
        },
        returnLatestDate(data) {
            let latestDate = new Date("0001-01-01");
            data.forEach((item) => {
                latestDate = moment(new Date(item.lastUpdatedDate)).isAfter(latestDate, "day") ? new Date(item.lastUpdatedDate) : latestDate;
            });
            return latestDate;
        },
        getConstraintDtlsForEdit() {
            this.shouldMovePrev = true;
            let payloadForNextYear = {
                plantId: this.plantId.plantId,
                yearOfGroup: this.oeeSelectedYear, // new Date().getFullYear()
                constraintMonth: this.oeeSelectedMonth
            };
            ApiCalls.httpCallDetails(Api.GETCONSTRAINTDETAILSFORNXTYR, "post", payloadForNextYear).then((dt) => {
                this.response = dt.data;
                this.constraintHeadersDtl = this.response.map((data) => {
                    data["isChecked"] = true;
                    return data;
                });
                console.log("Response", this.constraintHeadersDtl);
                this.lastUpdatedOn = moment(this.returnLatestDate(this.constraintHeadersDtl)).format("DD-MMM-YYYY");
                this.proceed();
            });
        },
        prevYearCheckBox(event, index) {
            this.constraintHeadersDtl[index].isChecked = event;
        },
        getValidityMonths(groupIds) {
            ApiCalls.httpCallDetails(Api.GETCONSTRAINTVALIDITY, "post", groupIds).then((data) => {
                data.data.sort((a, b) => {
                    if (a.endMonth > b.endMonth) return 1;
                    else return a.endMonth === b.endMonth ? 0 : -1
                });
                this.constraintValidityArr = data.data.map((item) => {
                    return {
                        historyFromMonth: moment(new Date(item.yearOfGroup, item.startMonth - 1, 1)).format("MMM-YYYY"),
                        historyToMonth: moment(new Date(item.yearOfGroup, item.endMonth - 1, 1)).format("MMM-YYYY"),
                        type: item.typeName
                    }
                });
                console.log(this.constraintValidityArr)

            });
        },
        proceed() {
            this.shouldMovePrev = true;
            this.showLoader = true;
            const prevGroupIds = [];
            this.constraintHeadersDtl.forEach((item) => {
                if (item.isChecked) prevGroupIds.push(item.groupId);
            });
            this.getValidityMonths(prevGroupIds);

            ApiCalls.httpCallDetails(Api.GETMACHINESBYOEECONSTRGROUPID, "post", prevGroupIds).then(async (dt) => {
                this.resp = dt.data;
                let tempGroupList = [];
                this.oldMachineList = [];
                dt.data.sort((a, b) => {
                    if (a.typeId < b.typeId) return 1;
                    else return a.typeId === b.typeId ? 0 : -1
                });
                await dt.data.forEach((item, ind) => {
                    let rawMachineList = [];
                    const prevMachieList = item.machines.map((machine) => machine.machineId);
                    let machinePayload = {
                        yearOfGroup: this.oeeSelectedYear,
                        plantId: this.plantId.plantId,
                        wcId: item.machines[0].wcId
                    };
                    console.log("machinePayload", machinePayload);
                    ApiCalls.httpCallDetails(Api.GETALLOEEMACHINES, "post", machinePayload).then((data) => {
                        let isAllChecked = 0;
                        rawMachineList = data.data.map((machine) => {
                            this.oldMachineList[machine.groupTypeName] = this.oldMachineList.hasOwnProperty(machine.groupTypeName) ? this.oldMachineList[machine.groupTypeName] : []
                            if (prevMachieList.includes(machine.machineId)) {
                                isAllChecked++;
                                this.oldMachineList[machine.groupTypeName].push(machine.machineId);
                            }
                            return {
                                machineId: machine.machineId,
                                machineName: machine.machineName,
                                machineChecked: prevMachieList.includes(machine.machineId)
                            };
                        });
                        console.log("***", this.oldMachineList);

                        rawMachineList.unshift({
                            machineId: 0,
                            machineName: "All",
                            machineChecked: isAllChecked === rawMachineList.length,
                            machineAlreadyMarked: false
                        });

                        tempGroupList.push({
                            groupId: item.groupId,
                            groupNo: ind + 1,
                            workCenterSelected: item.machines[0].wcId,
                            machineList: rawMachineList,
                            noOfMachinesforGrp: item.machines.length,
                            constraintGrpName: item.machines[0].constraintGroupName,
                            isPrevConstraint: "Y",
                            constraintTypeId: item.machines[0].contstaintType
                        });
                        console.log(item);
                        tempGroupList.sort((a, b) => {
                            if (a.constraintTypeId < b.constraintTypeId) return -1;
                            else return a.constraintTypeId === b.constraintTypeId ? 0 : 1
                        });
                        this.shouldMovePrev = true;
                        this.showLoader = false;
                        this.groupList = tempGroupList;
                    });
                });
                this.shouldMovePrev = true;
                this.showLoader = false;
            });
        },
        cancelList() {
            console.log("Inside cancelList");
            this.enableSecondList = false;
        },
        closeAlertPopup() {
            this.showPopup = false;
        },
        isPayloadValid(payLoad) {
            let valid = true;
            let totalMachines = [];
            payLoad.forEach((item, index) => {
                console.log(item.constraintGroupName.length, item.constraintGroupName.length < 2);
                if (item.constraintGroupName.length < 2) {
                    valid = false;
                    this.errorMsg = "Constrained WC Name is too short";
                    this.showPopup = true;
                    this.headText = "Error";
                } else if (item.contstaintType === "" || item.contstaintType === "-1") {
                    valid = false;
                    this.errorMsg = "Constrained Type is empty";
                    this.showPopup = true;
                    this.headText = "Error";
                } else if (item.totalMachines <= 0) {
                    valid = false;
                    this.errorMsg = "Machine is not selected. Please select at least one machine in Group.";
                    this.showPopup = true;
                    this.headText = "Error";
                } else if (item.isPreviousConstraint === "") {
                    valid = false;
                    this.errorMsg = "Please select previous constraint option.";
                    this.showPopup = true;
                    this.headText = "Error";
                }
                totalMachines = totalMachines.concat(item.machineIds);
                totalMachines = totalMachines.concat(item.newMachineIds);
            });
            valid = this.complexCheck(valid, totalMachines, payLoad)
            return valid;
        },
        complexCheck(valid, totalMachines, payLoad) {
            let uniqueList = Array.from(new Set(totalMachines));
            if (valid) {
                if (uniqueList.length !== totalMachines.length) {
                    valid = false;
                    this.errorMsg = "A machine can be tag to one group only.";
                    this.showPopup = true;
                    this.headText = "Error";
                } else if (
                    (payLoad.length > 1 && payLoad[0].contstaintType === payLoad[1].contstaintType) ||
                    (payLoad.length > 2 && (payLoad[0].contstaintType === payLoad[1].contstaintType) === payLoad[2].contstaintType)
                ) {
                    valid = false;
                    this.errorMsg = "Constraint type is same on both group";
                    this.showPopup = true;
                    this.headText = "Error";
                }
            }
            return valid
        },
        saveManualData() {
            this.showPopup = false;
            this.showLoader = true;
            const reqBody = this.groupList.map((groupItem, index) => {
                const machineList = [];
                const newMachineList = [];
                let typeName = groupItem.constraintTypeId === 3 ? 'Tertiary' : 'Secondary'
                typeName = groupItem.constraintTypeId === 2 ? 'Secondary' : 'Primary'
                groupItem.machineList.forEach((machine) => {
                    console.log(typeName, this.oldMachineList[typeName], machine.machineId)

                    if (machine.machineChecked && machine.machineId !== 0)
                        if (!this.oldMachineList[typeName].includes(machine.machineId)) newMachineList.push(machine.machineId);
                        else machineList.push(machine.machineId);
                });
                return {
                    groupId: groupItem.groupId,
                    constraintGroupName: groupItem.constraintGrpName,
                    contstaintType: groupItem.constraintTypeId,
                    yearOfGroup: this.committedYr,
                    wcId: groupItem.workCenterSelected,
                    totalMachines: groupItem.noOfMachinesforGrp,
                    lastUpdatedBy: this.$oidc.userProfile.email,
                    plantId: this.plantId.plantId,
                    machineIds: machineList,
                    newMachineIds: newMachineList
                };
            });
            console.log();
            this.saveApiCall(reqBody)
        },
        saveApiCall(reqBody) {

            if (!(reqBody.length === 1 && reqBody[0].contstaintType !== 1 && this.isPrimaryAvailable)) {
                if (this.isPayloadValid(reqBody)) {
                    ApiCalls.httpCallDetails(Api.UPDATEMROEECONSTRAINTGROUP, "put", reqBody).then((data) => {
                        this.showLoader = false;
                        console.log(data);
                        if (data.success && data.data.status) {
                            this.turnOffEditMode();
                        } else {
                            this.errorMsg = data.data.message.trim();
                            this.showPopup = true;
                            this.headText = "Error";
                        }
                    });
                } else {
                    this.showLoader = false;
                    console.log("Something wrong.");
                }
            } else {
                this.showLoader = false;
                this.errorMsg = "Please create primary constraint first.";
                this.showPopup = true;
                this.headText = "Error";
            }
        }
    }
};
</script>

<style scoped>
.individual-checkbox {
    width: 33%;
}

.constraint-heading-lbl {
    color: #234372;
    font: 1.166rem "BarlowM", sans-serif !important;
    padding: 0.25rem 1.2rem;
}

.plant-card-constraint {
    background: #fffce3;
    width: 22rem;
    height: 4.5rem;
    text-align: center;
    color: #414141;
    padding: 5px;
    border-radius: 7px;
}

.main-con {
    background: #fff;
    margin-top: 1em;
    border-radius: 6px;
}

/* ------- */
.edit-btn-div {
    text-align: end;
    position: absolute;
    margin-top: -42px;
    right: 55px;
}

.edit-btn {
    font: 1.16rem "BarlowSB", sans-serif !important;
    border: transparent;
    background: transparent;
    color: #274ba7;
}

.mat-info-con {
    padding: 2rem !important;
    display: flex;
}

.stacked-elements {
    padding: 2rem !important;
    display: flex;
    flex-direction: column;
}

.no-padding {
    padding: 0;
}

.border-box {
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    opacity: 1;
}

.no-data-block {
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
}

.scroll {
    height: 25rem;
}

.alter-of-border-box {
    display: flex;
    height: 25rem;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

.button-div {
    width: 22rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.chk-container {
    color: #313131;
    font-size: 1.1666666666666667rem;
    font-family: "BarlowR", sans-serif;
    padding: 0.7rem;
}

/* ------- */

.plant-dd {
    width: 20.5%;
}

.asmt-bt:disabled {
    cursor: not-allowed;
    opacity: 0.3;
}

.asmt-bt:hover {
    border-color: #869ed8 !important;
    color: #274ba7 !important;
    background: #cad0e4 0% 0% no-repeat padding-box !important;
}

.asmt-bt {
    border-color: #869ed8 !important;
    background: #eff3ff 0% 0% no-repeat padding-box !important;
    color: #274ba7 !important;
}

.mat-status-con {
    margin-left: 2rem;
    display: flex;
    align-items: center;
}

.machine-action-tracker {
    margin-top: 2rem;
    width: 100%;
}

#machine-action-tracker th.table-success {
    background-color: #f4f6fd;
}

#machine-action-tracker th:first-child,
#machine-action-tracker th:nth-child(2) {
    background-color: white !important;
    font-weight: medium;
}

#machine-action-tracker tr:nth-child(3n-2) td:first-child {
    border-bottom: 1px solid #eae6e6 !important;
}

#machine-action-tracker tr:nth-child(3n) td {
    border-bottom: 1px solid #eae6e6 !important;
}

.machine-action-tracker-label {
    text-align: center !important;
    vertical-align: middle !important;
    font-size: 1.333rem;
    font-family: "BarlowM", sans-serif;
}

.machine-action-table {
    max-height: 20rem !important;
}




/* .machine-action-table body tr td {
    color: #313131 !important;
    vertical-align: middle;
} */

.machine-action-table thead th,
.machine-action-table td {
    text-align: center !important;
    vertical-align: middle !important;
}

.machine-action-table thead th {
    background-color: #f7f9ff !important;
}

#machine-action-tracker>.machine-action-table th,
td {
    border: 0px !important;
    border-right: 1px solid #eae6e6 !important;
    border-left: 1px solid #eae6e6 !important;
}

.machine-action-table-machine {
    text-align: left !important;
    font-size: 1.166rem;
    font-family: "BarlowR", sans-serif;
}

.machine-action-table th:first-child {
    width: 15%;
}

.machine-action-table td,
.machine-action-table th div {
    color: #313131 !important;
    font-weight: 100;
}

.machine-action-table td tbody tr td {
    color: #313131 !important;
    vertical-align: middle;
}

.machine-action-table tbody tr:nth-child(even) {
    background-color: #f5f5ea !important;
}

.machine-action-table tbody tr:nth-child(odd) {
    background-color: #fafaf0 !important;
}

.machine-action-table .table-light,
.machine-action-table .table-light>td,
.machine-action-table .table-light>th {
    background-color: #f0f0f0 !important;
}

.machine-action-table body tr td {
    color: #313131 !important;
    vertical-align: middle;
}

.machine-action-table th.table-success {
    background-color: #f4f6fd;
}

.machine-action-table td.table-success {
    background-color: transparent;
}

.machine-action-table thead tr {
    border-bottom: 2px solid #dddddd !important;
}

.even-space-vertical-align {
    justify-content: space-between;
    align-items: center;
    display: flex;
}


@media only screen and (max-width: 767px) {
    .mat-info-con {
        display: block !important;
    }

    .plant-dd {
        width: 100% !important;
    }
}
</style>
